import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';
import iconNetworkOffSource from '@/assets/images/icon-network-off.svg';

const OfflineContainer: FunctionComponent = () => {
  const {t} = useTranslation();

  return (
    <div className="mx-4 flex max-w-screen-sm flex-col items-center justify-center rounded-3 bg-white px-4 py-12 text-center shadow-dialog">
      <img src={iconNetworkOffSource} alt="" className="mb-6 size-[32px]" />

      <div className="mb-2 text-xl font-semibold text-violet">{t('components.offline-container.title')}</div>

      <div className="text-base text-charcoal md:mx-16">{t('components.offline-container.description')}</div>
    </div>
  );
};

export default OfflineContainer;
